// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__27jlR","inputWrap":"Table_inputWrap__3v0HD","col":"Table_col__1Iyue","bmiTooltip":"Table_bmiTooltip__3LIAy"};